const TODAY = new Date();
TODAY.setDate(TODAY.getDate() - 1);

export { TODAY };